import moment from 'moment-timezone';

export function formatDate(date) {
  if (!date) {
    return '';
  }

  return moment(date)
    .tz('America/Chicago')
    .format('YYYY-MM-DD h:mm:ss A');
}

export function convertDate(date, options = { keepLocalTime: false }) {
  if (!date) {
    return '';
  }

  const momentDate = moment(date);

  if (!momentDate.isValid()) {
    return '';
  }

  return momentDate.tz('America/Chicago', options.keepLocalTime);
}
